import PageLayout from 'pages/ProfileSetup/PageLayout';
import PageProvider from 'pages/ProfileSetup/PageProvider';

const ProfileSetup = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout />
        </PageProvider>
    );
};

export default ProfileSetup;
